import React from 'react'
import { Theme, Typography } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import createStyles from '@mui/styles/createStyles'
import { ICharacter } from '../../../../../../../../../../api/types/character'
import { WeaponProfItem } from '../WeaponProfItem/WeaponProfItem'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    card: {
      padding: theme.spacing(1),
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
    },
  })
)

interface Props {
  char: ICharacter
  editable?: boolean
  onEdit?: (name: string, newValue: string) => void
}

export const CharacterWeaponProfs: React.FC<Props> = ({ char, editable, onEdit }) => {
  const classes = useStyles()

  interface WeaponProf {
    name: string
    stat: string
    value: number
  }

  const profs: WeaponProf[] = [
    {
      name: 'Walka wręcz',
      stat: 'arms',
      value: char.weapon_profs.arms,
    },
    {
      name: 'Małe ostrza',
      stat: 'small_blades',
      value: char.weapon_profs.small_blades,
    },
    {
      name: 'Miecze',
      stat: 'swords',
      value: char.weapon_profs.swords,
    },
    {
      name: 'Duże miecze',
      stat: 'big_swords',
      value: char.weapon_profs.big_swords,
    },
    {
      name: 'Obuchy',
      stat: 'blunts',
      value: char.weapon_profs.blunts,
    },
    {
      name: 'Broń drzewcowa',
      stat: 'poles',
      value: char.weapon_profs.poles,
    },
    {
      name: 'Łuki',
      stat: 'bows',
      value: char.weapon_profs.bows,
    },
    {
      name: 'Kusze',
      stat: 'crossbows',
      value: char.weapon_profs.crossbows,
    },
    {
      name: 'Broń miotana',
      stat: 'throwing',
      value: char.weapon_profs.throwing,
    },
  ]

  return (
    <div className={classes.card}>
      <Typography color="text.secondary" variant="caption" display="block" gutterBottom>
        Biegłości broni
      </Typography>
      {profs.map(({ name, value, stat }) => (
        <WeaponProfItem
          key={name}
          name={name}
          value={value}
          editable={editable}
          onEdit={v => onEdit && onEdit(stat, v)}
        />
      ))}
    </div>
  )
}
